module.exports = __webpack_public_path__ + "img/mobile-thumnail.45dabae4.svg";